module.exports = ".ml-10 {\n    margin-left: 10px;\n    font-size: 30px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/player/forward-play/forward-play.component.css
// module id = ./src/app/player/forward-play/forward-play.component.css
// module chunks = main